import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
	apiKey: 'AIzaSyCfbYrgrWCYvQxmRr9Z-XfMKBhI0Pc0tTk',
	authDomain: 'gb-web-ef873.firebaseapp.com',
	projectId: 'gb-web-ef873',
	storageBucket: 'gb-web-ef873.appspot.com',
	messagingSenderId: '524447915812',
	appId: '1:524447915812:web:387cc2ade8b2b41abf1db1',
	measurementId: 'G-8C19C2CM6K',
};

let apps = null;
let analytics = null;
let messaging = null;

/**
 * 仅在浏览器挂载后初始化 Firebase，避免 SSR 环境报错
 */
export async function setupFirebaseClient(app) {
	app.config.globalProperties.$logEvent = (event, params = {}) => {
		console.log(event);
		isSupported().then((result) => {
			if (result && analytics) {
				logEvent(analytics, event, params);
			}
		});
	};

	const ok = await isSupported();
	if (!ok) return;

	apps = initializeApp(firebaseConfig);
	analytics = getAnalytics(apps);
	logEvent(analytics, 'in_page_gb');

	try {
		messaging = getMessaging(apps);
		await requestNotificationFlow(app);
	} catch (e) {
		console.warn('Firebase messaging 初始化跳过', e);
	}
}

async function requestNotificationFlow(app) {
	if (typeof window === 'undefined' || !('Notification' in window)) return;

	const result = await Notification.requestPermission();
	if (result === 'denied') {
		app.config.globalProperties.$logEvent('game_outside_push_denied');
		return;
	}
	if (result === 'default') return;

	app.config.globalProperties.$logEvent('game_outside_push_permit');
	try {
		const currentToken = await getToken(messaging, {
			vapidKey: 'BC1jBojDWe5W81-h8LGbGy-wgbfk5DB7C0b8k78q937TzjovoUETC9lLkNEfoHg_HtA62wPBF8dZrfj08L8eDxM',
		});
		if (currentToken) {
			app.config.globalProperties.$logEvent('game_outside_success_init_user_token');
		}
	} catch (err) {
		console.log('获取设备令牌时出错。', err);
	}
}
